import React, { useState } from 'react';
import { Check, Link2 } from 'lucide-react';

/**
 * Native share links — no third-party JS or tracking.
 * Opens platform share intents in a new window; Copy uses navigator.clipboard.
 */
const ShareButtons = ({ title, url, organisation }) => {
  const [copied, setCopied] = useState(false);
  const shareUrl = url;
  const shareText = organisation
    ? `Check out this job: ${title} at ${organisation}`
    : `Check out this job: ${title}`;

  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedText = encodeURIComponent(shareText);

  const links = [
    {
      label: 'WhatsApp',
      testid: 'share-whatsapp',
      href: `https://wa.me/?text=${encodedText}%20${encodedUrl}`
    },
    {
      label: 'LinkedIn',
      testid: 'share-linkedin',
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`
    },
    {
      label: 'X',
      testid: 'share-twitter',
      href: `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`
    }
  ];

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      /* noop */
    }
  };

  return (
    <div className="mt-8 pt-6" style={{ borderTop: '1px solid #F0EBE2' }} data-testid="share-buttons">
      <p className="text-xs uppercase tracking-[0.2em] font-medium mb-4" style={{ color: '#D4820A' }}>
        Share this opportunity
      </p>
      <div className="flex flex-wrap gap-2">
        {links.map((l) => (
          <a
            key={l.label}
            href={l.href}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-4 py-2 rounded-full text-sm transition-all hover:bg-[#F0EBE2]"
            style={{
              backgroundColor: '#FFFFFF',
              border: '1px solid #F0EBE2',
              color: '#0F2942'
            }}
            data-testid={l.testid}
          >
            {l.label}
          </a>
        ))}
        <button
          type="button"
          onClick={handleCopy}
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm transition-all hover:bg-[#F0EBE2]"
          style={{
            backgroundColor: '#FFFFFF',
            border: '1px solid #F0EBE2',
            color: copied ? '#0F2942' : '#0F2942'
          }}
          data-testid="share-copy"
          aria-label="Copy link"
        >
          {copied ? (
            <>
              <Check className="w-3.5 h-3.5" strokeWidth={2} /> Copied
            </>
          ) : (
            <>
              <Link2 className="w-3.5 h-3.5" strokeWidth={1.75} /> Copy link
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default ShareButtons;
